import type { FormError, FormRecord } from 'models/formError';
import { ReactNode, useMemo } from 'react';
import type { InvalidFields } from 'state/selectors/meta/static/utils';
import { toInvalidFields } from 'state/selectors/meta/static/utils';

import { InvalidFieldsContext } from './InvalidFieldsContext';

type WithInvalidFieldsContextProps<
  Form = FormRecord,
  Keys extends string = string,
  KeysPrefix extends string = string,
> = Readonly<{
  children: ReactNode;
  validationErrors: readonly FormError<Form, Keys, KeysPrefix>[];
}>;
export function WithInvalidFieldsContext<
  Form = FormRecord,
  Keys extends string = string,
  KeysPrefix extends string = string,
>({ children, validationErrors }: WithInvalidFieldsContextProps<Form, Keys, KeysPrefix>) {
  const invalidFields = useMemo<InvalidFields<Form, Keys, KeysPrefix>>(
    () => toInvalidFields<Form, Keys, KeysPrefix>(validationErrors),
    [validationErrors],
  );

  return (
    <InvalidFieldsContext.Provider value={invalidFields as InvalidFields}>{children}</InvalidFieldsContext.Provider>
  );
}

WithInvalidFieldsContext.displayName = 'WithInvalidFieldsContext';
